module.exports = __webpack_public_path__ + "static/img/video_3.31d7bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_3.png
// module id = 20Zk
// module chunks = 1